/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.rules.controllers', [
  'ui.router',
  'acme.common.service.api'
])

.controller('MembershipRulesController', ['$scope', '$state', 'ApiService', function($scope, $state, ApiService) {

    $scope.membershipRules = {

      model: "Your spankin new application.membership.rules view!",

      init: function() {},

      isState: function(state) {
        return ($state.current.name.indexOf('application.membership.rules.'+state) === 0);
      },

      getState: function(name) {
        var self = $scope.membershipRules,
            stateName = 'application.membership.rules.' + name;

        self.save({
          name: stateName
        });
      },

      save: function(state) {
        $state.go(state.name);

        //ApiService.membership.rules.update();
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.membershipRules.init();

}]);